/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  AdnHttpSender,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {LocalNetworkProfile} from '../../../session/local-network-profile';

@Injectable({
  providedIn: 'root'
})
export class UserSegmentListService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService,
    @Inject(LocalNetworkProfile) private readonly localNetworkProfile: any
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(): any {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri('segments'),
      params: {pageSize: 200, includeInactive: false}
    });
  }

  query(segmentIds: any): any {
    segmentIds = _.isArray(segmentIds) ? segmentIds : [segmentIds];
    if (segmentIds.length === 0) {
      return Promise.resolve([]);
    }
    const networkId = this.localNetworkProfile.getNetworkId();
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri('segments'),
      params: {
        context: networkId,
        id: segmentIds.join(';'),
        pageSize: segmentIds.length
      }
    });
  }
}
